import { Button, Grid, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import warningIconUrl from '../../../../../../../assets/image/warning-icon.png';
import {
  useAuthenticationServiceContext,
  useNullableDomainContext,
} from '../../../../context/contexts';

export const GridWithHeight = styled(Grid)<{
  height: string;
}>`
  height: ${(props) => props.height};
` as typeof Grid;

const GridContainer = styled(Grid)`
  height: 95vh;
  align-content: center;
  width: 100%;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  text-align: center;
`;

const StyledButton = styled(Button)`
  background-color: #00a599;
  &:hover {
    background-color: rgba(27, 113, 107);
  }
`;

interface ErrorProps {
  image?: ReactNode;
  title: {
    key: string;
    options?: Record<string, string>;
  };
  message?: (t: TFunction) => ReactNode;
  exit?: (t: TFunction) => ReactNode;
}

export const Error = (props: ErrorProps) => {
  const {
    image = (
      <img
        src={warningIconUrl}
        width={'100%'}
        height={'100%'}
        style={{ objectFit: 'contain' }}
      />
    ),
    title,
    message = (t: TFunction) => (
      <Typography variant="h5">
        {t('pages:errorBoundary.contactAdministrator')}
      </Typography>
    ),
    exit = (t: TFunction) => (
      <StyledButton variant="contained" color="primary" onClick={logOut}>
        {t('pages:verifyEmail.logoutButtonText')}
      </StyledButton>
    ),
  } = props;
  const { t } = useTranslation();
  const authService = useAuthenticationServiceContext();
  const domain = useNullableDomainContext();

  const logOut = () => {
    localStorage.clear();
    void authService.logOutUser(domain);
  };

  return (
    <GridContainer container justifyContent="center">
      <GridWithHeight
        item
        container
        xs={12}
        height={'60vh'}
        justifyContent="center"
        alignContent="center"
      >
        <Grid
          item
          xs={5}
          sx={{
            justifyContent: 'center',
            alignContent: 'center',
            maxHeight: '60vh',
          }}
        >
          {image}
        </Grid>
      </GridWithHeight>
      <GridWithHeight
        justifyContent="center"
        height={'5vh'}
        item
        container
        xs={12}
      >
        <Typography variant="h5" style={{ color: 'palevioletred' }}>
          {t(title.key, { ...title.options })}
        </Typography>
      </GridWithHeight>
      <MessageContainer>{message(t)}</MessageContainer>
      <GridWithHeight
        justifyContent="center"
        height={'5vh'}
        item
        container
        xs={12}
      >
        {exit(t)}
      </GridWithHeight>
      <Button />
    </GridContainer>
  );
};

export default Error;
